import { put, takeLatest } from 'redux-saga/effects';
import { GetCodiciUtente } from '../../reducers/r_index';

import authService from './../../components/api-authorization/AuthorizeService';


// worker saga: makes the api call when triggerAction sees the action
export function* runAction() {
    try {

        const token = yield authService.getAccessToken();

        const response = yield fetch('/User/GetCodiciUtente', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        // array di codici utente
        const codici_utente = yield response.json();

        yield put(GetCodiciUtente.creators.getCodiciUtenteSuccess({ codici_utente }));

    } catch (e) {
        yield put(GetCodiciUtente.creators.getCodiciUtenteFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(GetCodiciUtente.types.GET_CODICI_UTENTE_REQUEST, runAction);
}

